<template lang="pug">
  div
    h3 {{$t('groupPages.modules.videos.title')}}
    ul.videos
      li(v-for='video in items')
        group-page-link-youtube(v-if="video.extension == ':youtube'", :link="video")
        vue-groupPage-link-dailymotion(v-if="video.extension == ':dailymotion'", :link="video")
        i.text-danger.trash.fa.fa-trash(v-if="openEditor", @click="removeLink(video)")
        //- i.text-muted.fa.fa-arrows.drag-handle(v-if="openEditor && module.items.length > 1")
    form.pt(v-if="openEditor", @submit.prevent="addUrl")
      .form-group
        label {{$t('groupPages.modules.videos.add')}}
        input.form-control(type="text", :placeholder="$t('groupPages.modules.videos.placeholder')", v-model='newUrl')
      button.btn.btn-primary.pull-right(type="submit") {{$t('globals.add')}}
      .cf  
</template>
<script type="text/javascript">
import GroupPageLinkYoutube from './GroupPageLinkYoutube'
import GroupPageLinkDailymotion from './GroupPageLinkDailymotion'

import api from '@/utils/api'

import _ from 'lodash'

export default {
  props: ['vueData', 'module', 'openEditor'],
  data () {
    return {
      newUrl: ''
    }
  },
  components: {
    GroupPageLinkYoutube,
    GroupPageLinkDailymotion
  },
  computed: {
    items () {
      let items = []
      for (let video of this.module.items) {
        items.push({
          src: video.downloadLink + '?size=3',
          description: video.name,
          url: video.url,
          extension: video.extension,
          id: video.id,
          file: video
        })
      }
      return items
    }
  },
  methods: {
    removeLink (link) {
      let index = _.findIndex(this.module.items, t => t.id === link.id)
      this.module.items.splice(index, 1)
      api.put('/node', {
        id: link.id,
        kind: 'file',
        public: false
      })
    },
    // onListReorder (event) {
    //   this.module.items.splice(event.newIndex, 0, this.module.items.splice(event.oldIndex, 1)[0])
    //   const oldItems = this.module.items
    //   this.module.items = []
    //   return this.$nextTick(() => {
    //     this.module.items = oldItems
    //     console.log('new list', this.module.items)
    //   })
    // },
    addUrl () {
      let newUrl = this.newUrl
      this.newUrl = ''
      api.post('/link', {
        url: newUrl,
        group: this.vueData.group.id
      }).then((response) => {
        let file = response.data.file
        this.module.items.push(file)
        api.put('/node', {
          id: file.id,
          kind: 'file',
          public: true
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// GroupPageVideos.vue?25328b66